"use client";

/**
 * The single `DirectionProvider` mount's client boundary (CLAUDE.md §2).
 *
 * ⚠️ **The wrapper is load-bearing — do not "simplify" it away.**
 * `app/[locale]/layout.tsx` is a server component, and importing
 * `@base-ui/react/direction-provider` there directly would need the `"use client"`
 * directive at the call site. That is the whole reason this file exists, and it is
 * the reason it is four lines rather than zero.
 *
 * ⚠️ It re-exported `useDirection` too, with **no importer** anywhere in `src`
 * (TRY-370) — the only other occurrence of the identifier was a comment in
 * `layout.tsx`. Dropped rather than kept "in case": an unused export is the orphan
 * shape this repo keeps paying for, it was this file's one lint error, and adding
 * it back is one line on the day something needs it. When that day comes, add it
 * HERE rather than importing the Base UI subpath at the call site — a client
 * component reading direction wants the same indirection the provider gets.
 */
export { DirectionProvider } from "@base-ui/react/direction-provider";
